
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interior-design-style-quiz/room-selection",
      function () {
        return require("private-next-pages/interior-design-style-quiz/room-selection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interior-design-style-quiz/room-selection"])
      });
    }
  